module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_kachel-tee.9ed31c56.png";